"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function getSiteId() {
  var siteId;

  if (typeof window !== 'undefined' && window.SITE_ID) {
    siteId = window.SITE_ID;
  } else {
    siteId = process.env.REACT_APP_SITE_ID || process.env.SITE_ID || 'BMAR';
  }

  if (!siteId) {
    throw new Error(' No se definio la variable de entorno SITE_ID o REACT_APP_SITE_ID');
  }

  return siteId;
}

exports.siteId = getSiteId();